import { render, staticRenderFns } from "./AbkSurveyQuestionForm.vue?vue&type=template&id=40647a4f&scoped=true&"
import script from "./AbkSurveyQuestionForm.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyQuestionForm.vue?vue&type=style&index=0&id=40647a4f&lang=scss&scoped=true&"
import style1 from "./AbkSurveyQuestionForm.vue?vue&type=style&index=1&id=40647a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40647a4f",
  null
  
)

export default component.exports